export default __webpack_public_path__ + "static/media/scene-02-ideas-begin-with-people.6d318b5d.png";